import {ReturnedMassProductItemProps} from "./ReturnedMassProductItem.types";
import styles from "./ReturnedMassProductItem.module.scss";
import React from "react";
import {ReturnInspectionStatus} from "@/models/Enums";
import MassProductViewModel from "@/models/server/MassProductViewModel";
import ToolsUtility from "@/helpers/ToolsUtility";
import Localizer from "@/localization/Localizer";
import {MassProductDetails} from "@/components/ReturnedMassProductItem/components/MassProductsDetails";
import Show from "../Show/Show";
import MassProductController from "@/pages/ReturnedMassProductController";

const ReturnedMassProductItem = ( { item, extendedView, index, lastRef, itemsLength } : ReturnedMassProductItemProps) => {
    const getStatusStyles = (item: MassProductViewModel): string => {
        switch (item.inspectionStatus) {
            case ReturnInspectionStatus.InProgress:
                return styles.inProgress;
            case ReturnInspectionStatus.Completed:
                return styles.completed;
            case ReturnInspectionStatus.PartlyCompleted:
                return styles.partlyCompleted;
        }
        
        return styles.waitingForReturnInspection;
    };

    const getDateText = (): string => {
        if (item.inspectionStatus === ReturnInspectionStatus.Completed) {
            return Localizer.returnInspectionListLastInspection;
        }
         
        return Localizer.returnInspectionListReturnedDate;
    };
    
    const onElementClick = () => {
        if(item.inspectionStatus === ReturnInspectionStatus.Waiting) {
            return MassProductController.StartReturnInspection(item.id);
        }
        
        if(item.inspectionStatus === ReturnInspectionStatus.InProgress || item.inspectionStatus === ReturnInspectionStatus.PartlyCompleted) {
            return MassProductController.ContinueReturnInspection(item.id);
        }
        
        if(item.inspectionStatus === ReturnInspectionStatus.Completed) {
            return MassProductController.ViewReturnInspection(item.id);
        }
    }
    
    return (
        <div id={`device_list_element_${item.contractId}`}
             className={styles.deviceListItem} 
             ref={index === itemsLength - 1 ? lastRef : undefined}
             onClick={() => onElementClick()}
        >
            <div data-cy={`device_status_bar_${item.contractId}`}
                 className={`${styles.priorityBar} ${getStatusStyles(item)}`}
            />
            <div className={styles.productInfo}>
                <span className={styles.fontBold}>{item.contractId}</span>
                <span>{item.customerName}</span>
                <span>{item.projectNumber}</span>
                <span>{item.productName}</span>
            </div>
            <div className={styles.dateInfo}>
                <span>{ToolsUtility.toDateString(item.returnedDate)}</span>
                <span>{getDateText()}</span>
            </div>
            <Show.When isTrue={extendedView}>
                <MassProductDetails details={item.massProductDetails} 
                                    returnInspectionStatus={item.inspectionStatus} 
                />
            </Show.When>
        </div>

    )
}


export default ReturnedMassProductItem;